import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { MenuItem } from 'primeng/api';
import { JWTService } from 'app/core/services/jwt.service';
import { AuthService } from 'app/core/services/auth.service';
import { UserRole } from 'app/core/enums/user-role.enum';

interface MenuItemWithRoles extends MenuItem {
  roles?: UserRole[];
}

@Injectable({
  providedIn: 'root',
})
export class MenuService {
  private menuItems$ = new BehaviorSubject<MenuItem[]>([]);
  public menuItems = this.menuItems$.asObservable();

  private readonly allMenuItems: MenuItemWithRoles[] = [
    {
      label: 'Propostas',
      icon: 'description',
      route: '/proposta',
      roles: [UserRole.SALES_REP, UserRole.ADMIN],
    },
    {
      label: 'Propostas',
      icon: 'description',
      route: '/proposta/avaliacao',
      roles: [UserRole.SALES_OPS, UserRole.ADMIN],
    },
  ];

  constructor(
    private jwtService: JWTService,
    private authService: AuthService,
  ) {
    this.buildMenu();

    this.authService.currentUser$.subscribe(user => {
      if (user) {
        this.buildMenu();
      } else {
        this.menuItems$.next([]);
      }
    });
  }

  private buildMenu(): void {
    const userRole = this.jwtService.getRole() as UserRole;

    if (!userRole) {
      this.menuItems$.next([]);
      return;
    }

    const filteredItems = this.allMenuItems
      .filter(item => !item.roles || item.roles.includes(userRole))
      .map(item => {
        const { ...menuItem } = item;
        return menuItem;
      });

    this.menuItems$.next(filteredItems);
  }

  public refreshMenu(): void {
    this.buildMenu();
  }
}
